import './CreatePlacePage.css'
import CreatePlaceForm from '../../components/CreatePlaceForm/CreatePlaceForm'
import { Container } from 'react-bootstrap'

const CreatePlacePage = () => {
    return (
        <Container>
            <CreatePlaceForm />
        </Container>
    )
}


export default CreatePlacePage